import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import config from 'config';

export default () => {
  const { data, ...query } = useQuery(
    ['GET', config.organizationId !== '' ? `/apis/v2/organizations/${config.organizationId}/presenting_issues` : '/apis/v2/presenting_issues', {}],
    {},
  );
  const { i18n } = useTranslation('labels');
  const presentingIssues = data?.data;
  const presentingIssuesOptions = useMemo(
    () => (presentingIssues || []).map((item) => ({ value: item.id, label: item.attributes[`label${i18n.language[0].toUpperCase()}${i18n.language.slice(1)}`] })),
    [i18n.language, presentingIssues],
  );

  return { data: presentingIssuesOptions, ...query };
};
